
import UserApi from '../../../api/UserApi';

import { useState } from "react";
import { Link } from 'react-router-dom';

const FindInfo = () => {

    const [target, setTarget] = useState('id');
    const [userNm, setUserNm] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const [loginId, setLoginId] = useState('');
    const [userEmail, setUserEmail] = useState('');

    const handleUserNmInput = e => setUserNm(e.target.value);
    const handlePhoneInput = e => setUserPhone(e.target.value);
    const handleIdInput = e => setLoginId(e.target.value);
    const handleEmailInput = e => setUserEmail(e.target.value);

    const handleFindClick = async () => {
        const res = await UserApi.findUserInfo({ target, userNm, userPhone, userId: loginId, userEmail });
        if (res.code === 'fail') return alert('아이디/비밀번호 찾기를 실패하였습니다. 잠시후 다시 시도해주세요.')
        if (target === 'id') return alert(`아이디는 '${res.userId}' 입니다.`);
        return alert('임시 비밀번호가 메일로 발송되었습니다.');
    }

    const handleKeyUpInput = e => {
        e.preventDefault();
        if (e.which !== 13) return;
        handleFindClick();
    }

    return (
        <div className="contents find-info">
            <div class="login-container">
                <div className="tab-menu">
                    <button className={`tab-btn ${target === 'id' && 'active'}`} onClick={() => setTarget('id')}>아이디 찾기</button>
                    <button className={`tab-btn ${target === 'pw' && 'active'}`} onClick={() => setTarget('pw')}>비밀번호 찾기</button>
                </div>
                <div class="login-form">
                    <div class="form-group">
                        { target === 'id' && <input type="text" placeholder="이름" value={userNm} onChange={handleUserNmInput} /> }
                        { target === 'pw' && <input type="text" placeholder="아이디" value={loginId} onChange={handleIdInput} /> }
                    </div>
                    <div class="form-group">
                        { target === 'id' && <input type="text" placeholder="전화번호" value={userPhone} onChange={handlePhoneInput} onKeyUp={handleKeyUpInput}/> }
                        { target === 'pw' && <input type="text" placeholder="이메일" value={userEmail} onChange={handleEmailInput} onKeyUp={handleKeyUpInput}/> }
                    </div>
                    <div class="button-group">
                        <button className='login-btn' onClick={handleFindClick}>찾기</button>
                    </div>
                </div>
                <div>
                    <Link to="/login">로그인</Link>
                </div>
            </div>
        </div>
    )
}

export default FindInfo;